export enum ObjectOwnerType {
  PRIVATE = 'PRIVATE',
  COMPANY = 'COMPANY'
}
